import React from 'react';
import { Reveal, RevealItem } from './Reveal';
export const FeaturesSection = () => {
  return <section className="pt-6 md:pt-14 pb-10 md:pb-14 px-[5vw] bg-bg relative overflow-hidden" data-id="element-122">
      {/* Decorative Elements */}
      <div className="absolute top-40 left-[5%] w-12 h-12 bg-rose opacity-20 rotate-45 pointer-events-none z-0" data-id="element-123"></div>
      <div className="absolute bottom-20 right-[5%] opacity-50 pointer-events-none z-0" data-id="element-124">
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-125">
          <pattern id="dots-features" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-126">
            <circle cx="2" cy="2" r="2" fill="var(--green-soft)" data-id="element-127" />
          </pattern>
          <rect width="100" height="100" fill="url(#dots-features)" data-id="element-128" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-129">
        <Reveal data-id="element-130">
          <div className="text-center mb-8 md:mb-16" data-id="element-131">
            <span className="font-caveat text-rose text-2xl block mb-4" data-id="element-132">
              o que o Aurora faz por você
            </span>
            <h2 className="font-serif font-bold text-[clamp(34px,5vw,56px)] tracking-[-0.02em] text-ink" data-id="element-133">
              Quatro telas. Quatro respostas. Adeus, achômetro.
            </h2>
          </div>
        </Reveal>

        <Reveal stagger data-id="element-134">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-135">
            {/* Card 1 */}
            <RevealItem className="bg-rose-soft rounded-[24px] md:rounded-[36px] p-5 md:p-10 md:min-h-[380px] relative overflow-hidden group hover:-translate-y-2 hover:rotate-1 transition-all duration-300" data-id="element-136">
              <div className="absolute -bottom-20 -right-20 w-64 h-64 border-[40px] border-rose opacity-20 rounded-full pointer-events-none" data-id="element-137"></div>

              <div className="w-10 h-10 md:w-16 md:h-16 bg-white rounded-full shadow-soft flex items-center justify-center text-lg md:text-2xl mb-4 md:mb-8 relative" data-id="element-138">
                <div className="absolute inset-0 border-2 border-dashed border-rose/30 rounded-full animate-[spin_12s_linear_infinite]" data-id="element-139"></div>
                📦
              </div>

              <h3 className="font-serif font-bold text-xl md:text-2xl text-[#1A1A1A] mb-2 md:mb-4 leading-tight" data-id="element-140">
                Cadastro de{' '}
                <span className="font-caveat text-rose text-2xl md:text-3xl" data-id="element-141">
                  materiais
                </span>
              </h3>

              <p className="text-[14px] md:text-[15px] text-[#1A1A1A]/80 leading-relaxed relative z-10" data-id="element-142">
                Cadastra uma vez e esquece. Você diz "comprei 100m de fita por
                R$ 32" — o app calcula que cada metro custa R$ 0,32. Da próxima
                vez que a fita subir, é só atualizar o preço da fita: TODOS os
                produtos que usam fita se reajustam sozinhos. Sem refazer nada.
              </p>
            </RevealItem>

            {/* Card 2 */}
            <RevealItem className="bg-rose rounded-[24px] md:rounded-[36px] p-5 md:p-10 md:min-h-[380px] relative overflow-hidden group hover:-translate-y-2 hover:-rotate-1 transition-all duration-300 text-white" data-id="element-143">
              <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-white opacity-15 rounded-[40px] rotate-12 pointer-events-none" data-id="element-144"></div>

              <div className="w-10 h-10 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center text-lg md:text-2xl mb-4 md:mb-8 relative backdrop-blur-sm" data-id="element-145">
                <div className="absolute inset-0 border-2 border-dashed border-white/40 rounded-full animate-[spin_12s_linear_infinite]" data-id="element-146"></div>
                🧮
              </div>

              <h3 className="font-serif font-bold text-xl md:text-2xl mb-2 md:mb-4 leading-tight" data-id="element-147">
                Cálculo de{' '}
                <span className="font-caveat text-white text-2xl md:text-3xl" data-id="element-148">
                  preço justo
                </span>
              </h3>

              <p className="text-[14px] md:text-[15px] text-white/90 leading-relaxed relative z-10" data-id="element-149">
                Você escolhe os materiais e o preço justo aparece na tela, em
                tempo real, com a margem que você quer. Se mexer na margem, o
                preço muda na hora. É o fim de "chutar e torcer".
              </p>
            </RevealItem>

            {/* Card 3 */}
            <RevealItem className="bg-gold rounded-[24px] md:rounded-[36px] p-5 md:p-10 md:min-h-[380px] relative overflow-hidden group hover:-translate-y-2 hover:rotate-1 transition-all duration-300 text-white" data-id="element-150">
              <div className="absolute bottom-0 right-0 w-full h-full opacity-40 pointer-events-none" style={{
              backgroundImage: 'radial-gradient(circle at 80% 80%, rgba(255,255,255,0.4) 2px, transparent 2px)',
              backgroundSize: '20px 20px'
            }} data-id="element-151"></div>

              <div className="w-10 h-10 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center text-lg md:text-2xl mb-4 md:mb-8 relative shadow-soft" data-id="element-152">
                <div className="absolute inset-0 border-2 border-dashed border-gold rounded-full animate-[spin_12s_linear_infinite]" data-id="element-153"></div>
                🛍️
              </div>

              <h3 className="font-serif font-bold text-xl md:text-2xl mb-2 md:mb-4 leading-tight" data-id="element-154">
                Gestão de{' '}
                <span className="font-caveat text-white text-2xl md:text-3xl" data-id="element-155">
                  pedidos
                </span>
              </h3>

              <p className="text-[14px] md:text-[15px] text-white/90 leading-relaxed relative z-10" data-id="element-156">
                Cada encomenda registrada com a cliente, a data e o que ela
                pediu. Você abre o app e vê o que entrega hoje, o que vence
                amanhã, e o que ainda nem começou. Adeus, encomenda esquecida no
                caderno.
              </p>
            </RevealItem>

            {/* Card 4 */}
            <RevealItem className="bg-green-soft rounded-[24px] md:rounded-[36px] p-5 md:p-10 md:min-h-[380px] relative overflow-hidden group hover:-translate-y-2 hover:-rotate-1 transition-all duration-300" data-id="element-157">
              <div className="absolute -bottom-16 -right-16 w-56 h-56 border-[32px] border-ink opacity-5 rounded-full pointer-events-none" data-id="element-158"></div>

              <div className="w-10 h-10 md:w-16 md:h-16 bg-white rounded-full shadow-soft flex items-center justify-center text-lg md:text-2xl mb-4 md:mb-8 relative" data-id="element-159">
                <div className="absolute inset-0 border-2 border-dashed border-ink/20 rounded-full animate-[spin_12s_linear_infinite]" data-id="element-160"></div>
                📊
              </div>

              <h3 className="font-serif font-bold text-xl md:text-2xl text-[#1A1A1A] mb-2 md:mb-4 leading-tight" data-id="element-161">
                Visão em{' '}
                <span className="font-caveat text-gold text-2xl md:text-3xl" data-id="element-162">
                  relatórios
                </span>
              </h3>

              <p className="text-[14px] md:text-[15px] text-[#1A1A1A]/80 leading-relaxed relative z-10" data-id="element-163">
                No fim do mês, você abre o app e sabe: faturei X, lucrei Y, meu
                produto mais lucrativo foi Z. Sem planilha. Sem somar nota
                fiscal. Sem perguntar pro marido se "tá dando certo".
              </p>
            </RevealItem>
          </div>
        </Reveal>
      </div>
    </section>;
};